/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_RedireccionInicio as RedireccionInicio,
} from "../../runtime/index.jsx";
export function PermisoRequerido(e) {
  let t = (0, ReactCompiler.c)(18),
    { icono: n, codigo: r, titulo: i, mensaje: a, acciones: o } = e,
    s;
  t[0] === o
    ? (s = t[1])
    : ((s = o === void 0 ? [] : o), (t[0] = o), (t[1] = s));
  let c = s,
    l;
  t[2] === n
    ? (l = t[3])
    : ((l =
        n &&
        (0, JSXRuntime.jsx)(n, {
          "aria-hidden": `true`,
          className: `h-10 w-10 text-(--text)`,
        })),
      (t[2] = n),
      (t[3] = l));
  let u;
  t[4] === r
    ? (u = t[5])
    : ((u = r && (
        <p
          className={`!m-0 text-xs font-semibold tracking-widest text-(--text)`}
          children={r}
        />
      )),
      (t[4] = r),
      (t[5] = u));
  let d;
  t[6] === i
    ? (d = t[7])
    : ((d = (
        <h1
          className={`!m-0 text-lg font-semibold text-(--text-h)`}
          children={i}
        />
      )),
      (t[6] = i),
      (t[7] = d));
  let f;
  t[8] === a
    ? (f = t[9])
    : ((f = a && (
        <p className={`!m-0 max-w-sm text-sm text-(--text)`} children={a} />
      )),
      (t[8] = a),
      (t[9] = f));
  let p;
  t[10] === c
    ? (p = t[11])
    : ((p = c.length > 0 && (
        <div
          className={`animar-entrada mt-2 flex flex-wrap items-center justify-center gap-2`}
          children={c.map(RedireccionInicio)}
        />
      )),
      (t[10] = c),
      (t[11] = p));
  let m;
  return (
    t[12] !== l || t[13] !== u || t[14] !== d || t[15] !== f || t[16] !== p
      ? ((m = (
          <main
            className={`fondo-punteado flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center`}
            children={[l, u, d, f, p]}
          />
        )),
        (t[12] = l),
        (t[13] = u),
        (t[14] = d),
        (t[15] = f),
        (t[16] = p),
        (t[17] = m))
      : (m = t[17]),
    m
  );
}
